var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardSolid = function SvgKeyboardSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.25A2.75 2.75 0 0 0 1.25 8v8A2.75 2.75 0 0 0 4 18.75h16A2.75 2.75 0 0 0 22.75 16V8A2.75 2.75 0 0 0 20 5.25H4ZM5.24 10a.75.75 0 0 1 .75-.75H6a.75.75 0 1 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Zm4.01 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75Zm3.99 0a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Zm4.01 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H18a.75.75 0 0 1-.75-.75ZM5.24 14a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Zm4.01 0a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Zm8 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H18a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgKeyboardSolid;